function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.172 2.17202C1.92211 1.42214 2.93934 1.00087 4 1.00087C5.06066 1.00087 6.07789 1.42214 6.828 2.17202L28 23.344L49.172 2.17202C49.541 1.78998 49.9824 1.48525 50.4704 1.27561C50.9584 1.06598 51.4833 0.955633 52.0144 0.951018C52.5455 0.946402 53.0722 1.04761 53.5638 1.24873C54.0554 1.44986 54.502 1.74687 54.8776 2.12244C55.2532 2.49801 55.5502 2.94462 55.7513 3.4362C55.9524 3.92779 56.0536 4.45451 56.049 4.98562C56.0444 5.51674 55.934 6.04162 55.7244 6.52964C55.5148 7.01765 55.21 7.45903 54.828 7.82802L33.656 29L54.828 50.172C55.5566 50.9264 55.9598 51.9368 55.9507 52.9856C55.9416 54.0344 55.5209 55.0377 54.7793 55.7793C54.0376 56.5209 53.0344 56.9416 51.9856 56.9507C50.9368 56.9598 49.9264 56.5567 49.172 55.828L28 34.656L6.828 55.828C6.07359 56.5567 5.06318 56.9598 4.01439 56.9507C2.96561 56.9416 1.96236 56.5209 1.22073 55.7793C0.479094 55.0377 0.0584167 54.0344 0.0493031 52.9856C0.0401894 51.9368 0.443369 50.9264 1.172 50.172L22.344 29L1.172 7.82802C0.422117 7.07791 0.000854492 6.06068 0.000854492 5.00002C0.000854492 3.93936 0.422117 2.92213 1.172 2.17202Z",
  fill: "url(#paint0_radial)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(14.8708 16.4851) rotate(44.6354) scale(57.8679 58.2697)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0207333,
  stopColor: "white",
  stopOpacity: 0.9
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.0214619,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39517,
  stopColor: "white",
  stopOpacity: 0.96
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.8
})));

var SvgXmark = function SvgXmark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgXmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/xmark.e427e76c.svg";
export { ForwardRef as ReactComponent };